import { ReactNode } from 'react';
import { useGetMachineUtilizationQuery } from 'api';
import { useDateRange } from 'components';
import { useMachineInfo } from 'common/pages/fleetV2/providers';
import { format } from 'date-fns';

type UseMachineOverviewWidgetProps = {
  machineId?: string;
  pollingInterval?: number;
  granularity?: string;
};

export const useMachineUtilizationWidget = (props: UseMachineOverviewWidgetProps = {}): {
  isLoading?: boolean;
  isFetching?: boolean;
  hasError?: ReactNode;
  hasMessage?: ReactNode;
  [key: string]: unknown;
} => {
  const { dateRange } = useDateRange();
  const machineInfo = useMachineInfo();
  const machineId = props.machineId ?? machineInfo.machineId;
  const startDatetime = format(dateRange.startTime, "yyyy-MM-dd'T'HH:mm:ss");
  const endDatetime = format(dateRange.endTime, "yyyy-MM-dd'T'HH:mm:ss");

  const { data, isLoading, isError, isFetching, refetch } = useGetMachineUtilizationQuery({
    machineId: machineId as string,
    startDatetime,
    endDatetime,
    ...(props.granularity && { granularity: props.granularity })
  }, {pollingInterval: props.pollingInterval});

  return {
    isLoading,
    isFetching,
    hasError: isError,
    data,
    refetch
  };
};
